import PaymentsList from './PaymentsList';

export default {
    list: PaymentsList,
}